import React, { useState, useEffect } from "react";
import {
  FaBars,
  FaTachometerAlt,
  FaSignOutAlt,
} from "react-icons/fa";
import { MdLocalPharmacy } from "react-icons/md";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./style.css";

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  useEffect(() => {
  }, [location.pathname]);

  const toggleSubMenu = () => {
    // Manually open/close karne ke liye
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    navigate("/");
  };

  return (
    <aside className={`dashboard-sidebar ${isSidebarOpen ? "open" : "collapsed"}`}>
      <div className="sidebar-header">
        <button className="toggle-btn" onClick={toggleSidebar}>
          <FaBars />
        </button>
        {isSidebarOpen && <span className="sidebar-title">SGTU Dashboard</span>}
      </div>

      <div className="sidebar-menu">
        <Link
          to="/dashboard"
          className={`sidebar-link ${location.pathname === "/dashboard" ? "active" : ""}`}
        >
          <FaTachometerAlt />
          {isSidebarOpen && "Dashboard"}
        </Link>

        <Link
          to="/pharmacyData"
          className={`sidebar-link ${location.pathname === "/pharmacyData" ? "active" : ""}`}
        >
          <MdLocalPharmacy />
          {isSidebarOpen && "Pharmacy"}
        </Link>

        <div className="sidebar-link logout-btn" onClick={handleLogout}>
          <FaSignOutAlt />
          {isSidebarOpen && "Logout"}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;